/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-05-17 16:28:28
 */
import Vue from 'vue';

Vue.directive('auto-trim',{
    bind(el,binding,vnode){
        el.addEventListener('blur',ev=>{
            const trimedText = el.value!=null?el.value.trim():el.value;
            if(trimedText != el.value){
                el.value = trimedText;
            }
        });
    }
});